export var Defaults = {
    destinationURL: '',
    serviceURL: 'https://sp10044311.guided.ss-omtrdc.net/',
    additionalParams: null,
    searchParams: null
};
